// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { type AuthUser } from '@/types';

export default defineNuxtRouteMiddleware((middleware) => {
  const { isAuthenticated } = useSanctumAuth();
  const user: Ref<AuthUser | null> = useSanctumUser();
  const uuid = user.value?.researcher?.uuid;

  // The reports page is addressed by researcher uuid, so there is nowhere to
  // send someone who has no researcher record — an admin, say. Redirecting on
  // `user.value` alone interpolated an absent uuid and sent them to
  // /researchers/undefined/in-review, which then asked the API for
  // /researchers/undefined/vulnerabilities/in-review and took a 500.
  if (isAuthenticated.value && uuid) {
    return navigateTo(`/researchers/${uuid}/in-review`);
  }
});
